import React, { useEffect } from 'react';
import { View } from 'react-native';

import tw from '../../../../styles/tailwind';
import { useVideoPlayer, VideoView } from 'expo-video';

import IconButton from '../../../../components/IconButton';

const videoSource =
  'https://ding-dong.s3.us-west-1.amazonaws.com/files/real-madeira/HowtoQR.mp4';

export default function IntroSection({ onNextPressed }) {
  const player = useVideoPlayer(videoSource, player => {
    player.loop = true;
    player.play();
  });

  useEffect(() => {
    return () => {
      player.pause();
    };
  }, [player]);

  return (
    <View style={tw`flex-1 justify-around`}>
      <View style={tw`h-80% mt-4 mb-4`}>
        <VideoView
          style={tw`flex-1`}
          player={player}
          contentFit="contain"
          allowsFullscreen
          allowsPictureInPicture
        />
      </View>

      <IconButton
        color="secondary"
        style={tw`py-4`}
        title="Continuar"
        onPress={onNextPressed}
      />
    </View>
  );
}